module.exports = __webpack_public_path__ + "static/media/shader.9809084b.glsl";


//////////////////
// WEBPACK FOOTER
// ./src/experiments/Shader/shader.glsl
// module id = 53
// module chunks = 5